import { tns } from 'tiny-slider/src/tiny-slider'

// Block slider
export function initProductsSlider (name) {
	const elements = document.querySelectorAll('[data-slider="' + name + '"]')
	if (!elements) return;
	// const nav = document.querySelector('[data-slider-nav="' + name + '"]')
	let sliders = [];
	// don't start function if the element is not on the page

	elements.forEach((element) => {

		if (!element) return;

		const slider = tns({
			container: element,
			items: 3,
			mouseDrag: true,
			autoplay: true,
			autoplayTimeout: 5000,
			controls: false,
			rewind: true,
			loop: false,
			nav: false,
			autoplayButtonOutput: false,
			navPosition: 'bottom',
			gutter: 20,
			responsive: {
				0: {
					items: 2,
					edgePadding: 0,
					gutter: 5
				},
				768: {
					items: 3,
					edgePadding: 30
				},
				1200: {
					edgePadding: 0,
					items: 4,
					autoWidth: true,
				}
			}
		});

		sliders.push[slider];
	});

	return sliders
}
